import React from 'react';
import { Link } from 'reaouter';
import { findByText } from 'Common/Utils';
import { HookShotChaperone, ClickGesture } from 'Snippets/Redundancy';
export const AdvanceDesignPattern = [ 
	{
		message: (
			<>
				For advance design pattern. We included from the <b>formydable</b>{' '}
				<b>import</b>, the <b>useFormSupplier</b> and <b>FormSupplier</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:useFormSupplier')[0];
		},
	},
	{
		message: (
			<>
				Then we create a container component that handles the form submission...
			</>
		),
		find(target) {
			return findByText(target, 'span:FormWrapper')[0];
		},
	},
	{
		message: (
			<>
				This component must contain a property of <b>children</b> to render the
				form fields inside form and <b>onSubmit</b> to passed it on{' '}
				<b>formSubmit</b> to handle the submission...
			</>
		),
		find(target) {
			return findByText(target, 'span:children')[0];
		},
	},
	{
		message: (
			<>
				As you observe the <b>useForm</b>. We didn't register a schema. But We
				return the last and 4th function. the <b>formRegistry</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:useForm')[2];
		},
	},
	{
		message: (
			<>
				Because <b>formRegistry</b> will handle all the registry this time. but
				how? there are no form fields inside...
			</>
		),
		find(target) {
			return findByText(target, 'span:formRegistry')[0];
		},
	},
	{
		message: (
			<>
				Here is how... We will going to use the <b>FormSupplier</b> to supply
				the 3 form fields important functions. Firstly, the <b>formState</b> to
				get fields state. Secondly, The <b>formUpdate</b> to handle changes. And
				lastly, The <b>formRegistry</b> to register the fields into the
				schema...
			</>
		),
		find(target) {
			return findByText(target, 'span:FormSupplier')[2];
		},
	},
	{
		message: (
			<>
				And we will set those functions in value property of <b>FormSupplier</b>
				. so that later on, the children fields can get those functions using
				the <b>useFormSupplier</b>
				...
			</>
		),
		find(target) {
			return findByText(target, 'span:value')[0];
		},
	},
	{
		message: (
			<>
				And don't forget to set <b>onSubmit</b> handler on the <b>form</b>. And
				that's it for our container component...
			</>
		),
		find(target) {
			return findByText(target, 'span:formSubmitHandler')[1];
		},
	},
	{
		message: (
			<>
				And now, We will create a form field component that is related to our
				container component...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputWithRules ')[0];
		},
	},
	{
		message: (
			<>
				This component is just a typical input field with a property of{' '}
				<b>type</b>, <b>id</b>, <b>name</b>, <b>value</b>, and{' '}
				<b>placeholder</b>. But since this component is reusable we will add{' '}
				<b>label</b> to set a label for both form registry and physical, And
				especially don't forget the main attraction of this library, the{' '}
				<b>rules</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:rules')[0];
		},
	},
	{
		message: (
			<>
				Now we will get the functions supplied by <b>FormSupplier</b>. by using{' '}
				<b>useFormSupplier</b>
			</>
		),
		find(target) {
			return findByText(target, 'span:useFormSupplier')[1];
		},
	},
	{
		message: (
			<>
				Since we already know the <b>formState</b> and <b>formUpdate</b> from
				the earlier demos. what I want to emphasize is the <b>formRegistry</b>,
				because it is new to us...
			</>
		),
		find(target) {
			return findByText(target, 'span:formRegistry')[2];
		},
	},
	{
		message: (
			<>
				Using <b>formRegistry</b> you must passed an object that containing{' '}
				<b>name</b>, <b>label</b>, <b>value</b>, and <b>rules</b>. <b>name</b> which is the
				same with the input's attribute name. it is use to identify it's state when using{' '}
				<b>formUpdate</b>. <b>label</b> which will be use for labeling error
				messages. <b>value</b> which is use in controllable field to put default value in schema. 
				And lastly the <b>rules</b>... you know what rules is for...
			</>
		),
		find(target) {
			return findByText(target, 'span:rules')[1];
		},
	},
	{
		message: (
			<>
				Then we will single fetch the field state by passing the <b>name</b> as
				identifier on <b>formState</b>. so it will know which is which...
			</>
		),
		find(target) {
			return findByText(target, 'span:formState')[3];
		},
	},
	{
		message: (
			<>
				In <Link to="/neumorphism" label="Neumorphism" /> class <b>n-form-field</b>. You can set another class{' '}
				<b>n-form-invalid</b> to show the red border that signifies invalid. And
				class <b>n-form-valid</b> which shows green border that is signifies
				valid...
			</>
		),
		find(target) {
			return findByText(target, 'span:validity')[0];
		},
	},
	{
		message: (
			<>
				In the statement we use field state property <b>isInvalid</b> to
				determine if it is invalid. Then, We will set a string <b>n-form-invalid</b>
				...
			</>
		),
		find(target) {
			return findByText(target, 'span:isInvalid')[0];
		},
	},
	{
		message: (
			<>
				Or else using field state property <b>isValidated</b> to determine if
				the form field is already touched by the user or validated. Then, We
				will set a string <b>n-form-valid</b>. Otherwise it will set a empty
				string...
			</>
		),
		find(target) {
			return findByText(target, 'span:isValidated')[0];
		},
	},
	{
		message: (
			<>
				Then we set the component properties in form field perspective places...
			</>
		),
		find(target) {
			return findByText(target, 'span:n-form-field')[0];
		},
	},
	{
		message: (
			<>
				And before I finish in our form field component(<b>InputWithRules</b>),
				I want you to know why I ignore the <b>type "file"</b> from the
				circulation of controllable fields. it is because <b>type "file"</b>{' '}
				default value is not assignable...
			</>
		),
		find(target) {
			return findByText(target, 'span:"file"')[0];
		},
	},
	{
		message: (
			<>
				Finally, We will going to use our newly created components.{' '}
				<b>FormWrapper</b> and <b>InputWithRules</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:FormWrapper')[1];
		},
	},
	{
		message: (
			<>
				Then, We will going to assign our submit handler in container(
				<b>FormWrapper</b>) <b>onSubmit</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:onSubmit')[3];
		},
		...HookShotChaperone({
			target: (target) => findByText(target, 'span:onSubmit')[3],
			from: (target) => findByText(target, 'span:MockSubmit')[1],
			to: (target) => findByText(target, 'span:MockSubmit')[0],
		}),
	},
	{
		message: (
			<>
				And then, We put our form field component(<b>InputWithRules</b>) inside
				container(
				<b>FormWrapper</b>)...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputWithRules')[1];
		},
	},
	{
		message: <>Well done!! Let's try out the result!</>,
		find: 'input',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];

// note if the there is not rules assign on formRegistry it will ignore it and will not register but it still do -
// unessesary functionalites that is why i make a statement since it will be ignore
